import { useEffect, useState } from 'react'

export interface ThemeSong {
  id: string
  title: string
  artists: string[]
  album_image_url: string | null
  ride_count: number
}

export interface ThemeArtist {
  id: string
  name: string
  image_url: string | null
  play_count: number
}

export interface MissingEssential {
  rank: number
  artist_name: string
  track_name: string
  artist_already_played: boolean
}

export interface InstructorThemeDetail {
  instructor: { id: string; name: string; image_url: string | null }
  theme: string
  ride_count: number
  top_songs: ThemeSong[]
  top_artists: ThemeArtist[]
  missing_essentials: MissingEssential[]
}

export function useInstructorThemeStats(instructorId: string | undefined, theme: string | undefined) {
  const [data, setData] = useState<InstructorThemeDetail | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!instructorId || !theme) return

    let cancelled = false
    setData(null)
    setError(null)

    fetch(`/api/instructors/${instructorId}/themes/${encodeURIComponent(theme)}`, {
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Request failed: ${response.status}`)
        return response.json() as Promise<InstructorThemeDetail>
      })
      .then((json) => {
        if (!cancelled) setData(json)
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load theme')
      })

    return () => {
      cancelled = true
    }
  }, [instructorId, theme])

  return { data, error }
}
